import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const ServicePricingCard = ({ service, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [price, setPrice] = useState(service?.price);

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY',
      minimumFractionDigits: 2
    })?.format(amount);
  };

  const handleSave = () => {
    onUpdate(service?.id, price);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setPrice(service?.price);
    setIsEditing(false);
  };

  const getServiceIcon = (type) => {
    switch (type) {
      case 'video':
        return 'Video';
      case 'story':
        return 'Image';
      case 'post':
        return 'FileText';
      case 'reel':
        return 'Film';
      default:
        return 'Package';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name={getServiceIcon(service?.type)} size={24} color="var(--color-primary)" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">{service?.name}</h3>
            <p className="text-sm text-muted-foreground">{service?.description}</p>
          </div>
        </div>
        {!isEditing && (
          <button
            onClick={() => setIsEditing(true)}
            className="p-2 hover:bg-muted rounded-md transition-smooth"
            aria-label="Fiyatı düzenle"
          >
            <Icon name="Edit2" size={18} />
          </button>
        )}
      </div>
      {isEditing ? (
        <div className="space-y-4">
          <Input
            type="number"
            label="Fiyat (₺)"
            value={price}
            onChange={(e) => setPrice(parseFloat(e?.target?.value))}
            placeholder="0.00"
            min="0"
            step="0.01"
          />
          <div className="flex items-center gap-2">
            <Button variant="default" onClick={handleSave} className="flex-1">
              Kaydet
            </Button>
            <Button variant="outline" onClick={handleCancel} className="flex-1">
              İptal
            </Button>
          </div>
        </div>
      ) : (
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">Mevcut Fiyat</span>
            <span className="text-2xl font-bold text-primary">{formatCurrency(service?.price)}</span>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Platform Komisyonu (15%)</span>
            <span className="text-foreground font-medium">{formatCurrency(service?.price * 0.15)}</span>
          </div>
          <div className="flex items-center justify-between pt-3 border-t border-border">
            <span className="text-sm font-semibold text-foreground">Net Kazanç</span>
            <span className="text-lg font-bold text-success">{formatCurrency(service?.price * 0.85)}</span>
          </div>
        </div>
      )}
      <div className="mt-4 pt-4 border-t border-border">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground flex items-center gap-1">
            <Icon name="TrendingUp" size={14} />
            Son 30 gün
          </span>
          <span className="font-medium text-foreground">{service?.ordersCount} sipariş</span>
        </div>
      </div>
    </div>
  );
};

export default ServicePricingCard;